import { actions as notificationActions } from '@saucelabs/sl-container-notifications';
import { actions as modalActions } from '@saucelabs/sl-container-modal';

import * as actions from './actions';
import * as selectors from './selectors';
import {
  actions as activityActions,
  constants as activityConstants,
  utils as activityUtils,
} from './../../ducks/activity';
import { CTA_EVENTS, trackEvent } from '../../tracking';
import { name as addGroupModalName } from '../../groups/components/AddGroupModal';

export const initialize = () => (dispatch) => (
  dispatch(actions.getGroupList())
    .then((response) => {
      const groupIds = response.data.results.map((group) => group.id);

      if (!groupIds.length) {
        return response;
      }

      return dispatch(activityActions.getGroupsActivity({
        groupIds,
        since: activityUtils.xDaysAgo(activityConstants.CHARTS_DATA_PERIOD),
      }));
    })
);

export const createGroup = (payload) => (dispatch, getState) => {
  dispatch(trackEvent(CTA_EVENTS.ADD_GROUP_MODAL.SUBMIT));
  const organizationId = selectors.organizationSelector(getState()).organization.id;
  return dispatch(actions.createGroup({ ...payload, organizationId }))
    .then(() => dispatch(notificationActions.notifySuccess('Line of business created!')));
};

export const moveGroupsTeams = ({ from, to }) => (dispatch, getState) => {
  const allGroups = selectors.groupsSelector(getState()).groups;

  const promises = from.map(async (groupId) => {
    try {
      return await dispatch(actions.moveGroupTeams({ from: groupId, to }));
    } catch (error) {
      const groupName = allGroups.get(groupId).name;
      dispatch(notificationActions.notifyDanger(`Unable to move teams from line of business: ${groupName}`));
      throw error;
    }
  });

  return Promise.all(promises);
};

export const removeGroups = (groupIds) => async (dispatch, getState) => {
  const allGroups = selectors.groupsSelector(getState()).groups;

  const promises = groupIds.map(async (groupId) => {
    try {
      return await dispatch(actions.removeGroup({ id: groupId }));
    } catch (error) {
      const groupName = allGroups.get(groupId).name;
      dispatch(notificationActions.notifyDanger(`Unable to delete line of business: ${groupName}`));
      throw error;
    }
  });

  const results = await Promise.all(promises);
  dispatch(notificationActions.notifySuccess('Lines of business have been removed!'));

  return results;
};

export const showGroupAddModal = () => (dispatch) => {
  dispatch(trackEvent(CTA_EVENTS.ADD_GROUP_MODAL.OPEN));
  dispatch(modalActions.showModal(addGroupModalName));
};
